import { CellClassParams, CellStyle } from 'ag-grid-community';

export const cellStyleBold = (params: CellClassParams): CellStyle =>
    params.node.aggData ? { fontWeight: 600 } : {};
